import React, { useState } from 'react';

const FAQKeyword = ({ title = "Frequently Asked Questions", faqs = [] }) => {
  const [openFAQId, setOpenFAQId] = useState(null);

  const toggleFAQ = (id) => {
    setOpenFAQId(prevId => (prevId === id ? null : id));
  };

  return (
    <section className="faq py-5">
      <div className="container">
        <div className="row flex-row-reverse">
          <div className="col-12">
            <div className="faq-content">
              <h3 className="mb-4">{title}</h3>
              {faqs.map(({ question, answer }, index) => {
                const isOpen = openFAQId === index;
                return (
                  <div
                    key={index}
                    className="faq-item mb-3 p-3 border rounded"
                    style={{ cursor: 'pointer', background: '#f9f9f9' }}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="d-flex align-items-center">
                      <i
                        className={`fa ${isOpen ? 'fa-minus' : 'fa-plus'} me-2`}
                        aria-hidden="true"
                      ></i>
                      <p className="question fw-bold mb-0">{question}</p>
                    </div>
                    {isOpen && (
                      <div className="faq-para mt-2 text-muted">{answer}</div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQKeyword;
